export default __webpack_public_path__ + "static/media/4.45bebbc1.jpg";